module.exports = __webpack_public_path__ + "img/pc1.ea64af4e.png";